import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'lus-address-validation-dialog',
    templateUrl: './address-validation-dialog.component.html',
    styleUrls: ['./address-validation-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressValidationDialogComponent implements OnInit {
    propertyListForm: UntypedFormGroup;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<AddressValidationDialogComponent>,
        private fb: UntypedFormBuilder,) { }

    ngOnInit(): void {
        this.propertyListForm = this.fb.group({
            property: [null, [Validators.required]]
        });
    }

    onCancel(): void {
        this.dialogRef.close({ action: false });
    }

    onNext() {
        this.dialogRef.close(
            {
                action: true,
                selectedProperty: this.propertyListForm.get('property').value
            }
        );
    }

}
